import { themes } from "./themes"

export const themeForApp = (osTheme: "light" | "dark", user: { settings?: { theme?: string } } | undefined) => {
  if (user?.settings?.theme) {
    const theme = themes.find((f) => f.name === user!.settings!.theme)
    if (theme) return theme
  }
  return osTheme === "dark" ? themes[1] : themes[0]
}
